
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edogdblWqRfKQJPceWKzVVkJ077_ila9Qkq36OipApCDUYMeta } from "/var/www/2025-10-08_20_30/pages/edo.vue?macro=true";
import { default as helpsv402_Ep8kUxftikktCsWxsh2k2zPYdRLSGieAyMbn8Meta } from "/var/www/2025-10-08_20_30/pages/help.vue?macro=true";
import { default as cargoM_YvDPsmXFod4HeGzeolGN4TIvrpiwSabaQhqgRxGHkMeta } from "/var/www/2025-10-08_20_30/pages/cargo.vue?macro=true";
import { default as indexquM6oneyU7LvbweQ0WEYMfxZ2U5b9caWJc162hHjkHgMeta } from "/var/www/2025-10-08_20_30/pages/index.vue?macro=true";
import { default as _91slug_93MZjQdvuEGdGgyWwYbOeMTMFNhEsM_QdOhwntSvQ5HYkMeta } from "/var/www/2025-10-08_20_30/pages/[slug].vue?macro=true";
import { default as cookieTgI8BEg61qlzlOhdBUggQ_45_cNdGC5Ci2m6eQmo_45nLtkMeta } from "/var/www/2025-10-08_20_30/pages/cookie.vue?macro=true";
import { default as surveyKkZqFBMjKfKcthnF4GFRlxzI6BfhowN0wUUzbi91JXoMeta } from "/var/www/2025-10-08_20_30/pages/survey.vue?macro=true";
import { default as belarusXcyYBY_45HvzXSUSTeTqB5NOBdPVk1LrwCEZ97_45FhlwoEMeta } from "/var/www/2025-10-08_20_30/pages/belarus.vue?macro=true";
import { default as bonusesM8JSHb8KLTOyVkj1970KlQ2FNPA1DO_45CGnqThtLbRrwMeta } from "/var/www/2025-10-08_20_30/pages/bonuses.vue?macro=true";
import { default as apiBwjsJeeYd2kJumXs_xRV0vSCOK9I6wl0DkmyENUA8_45wMeta } from "/var/www/2025-10-08_20_30/pages/dev/api.vue?macro=true";
import { default as cmsRhoVejbde1NyGmVx6cjt1eVv8sd9ZeOrNkSnEg61xgwMeta } from "/var/www/2025-10-08_20_30/pages/dev/cms.vue?macro=true";
import { default as konkursrZEyNpRUKD7m7xnPEArHbecedJ8A1icXHiWfHJFW8ysMeta } from "/var/www/2025-10-08_20_30/pages/konkurs.vue?macro=true";
import { default as successimvfrc5VXcdwf45wEfEcPnZP_DtGe0S05jR3wabIz3EMeta } from "/var/www/2025-10-08_20_30/pages/success.vue?macro=true";
import { default as vacancyJQiodfBvqFiAVuoQLILyNWCu5Bz2ZcxtUUtNiKhkRKEMeta } from "/var/www/2025-10-08_20_30/pages/vacancy.vue?macro=true";
import { default as contactsxlD60LNA0WJRMQ9OwG_hZR8K2dtjf69CmhU7bjOlzCQMeta } from "/var/www/2025-10-08_20_30/pages/contacts.vue?macro=true";
import { default as giveawayZS_45npTbrk7TRVQ45dXGKopxtAjItJEmBLGBHATMcmRAMeta } from "/var/www/2025-10-08_20_30/pages/giveaway.vue?macro=true";
import { default as guide_45lkCsFBSeVi4e2yrGFhA8j8zdQkwIdbiYLABogzPy_455WksMeta } from "/var/www/2025-10-08_20_30/pages/guide-lk.vue?macro=true";
import { default as services2X0sVFucD2gbxNuqFn526Q9rS_4535_da6VjWjhcHum_sMeta } from "/var/www/2025-10-08_20_30/pages/services.vue?macro=true";
import { default as telegramHYLn95M9xu3Tan_L7AbJ2etxM_M7z2mzEuwLHGv16RsMeta } from "/var/www/2025-10-08_20_30/pages/telegram.vue?macro=true";
import { default as documentsHPj55zME_EMEqKuAprIXwa2tjr6Uh_45IR6F_vatIBvRUMeta } from "/var/www/2025-10-08_20_30/pages/documents.vue?macro=true";
import { default as franchiseirsm_Q_45AjIkrM_45kVREPw7TcFVemOeCMKayyg3cwOND0Meta } from "/var/www/2025-10-08_20_30/pages/franchise.vue?macro=true";
import { default as insurancewgoxpchYzTO4_eaqBYEflJSCT_D4lzzpRQ84hIcu_c4Meta } from "/var/www/2025-10-08_20_30/pages/insurance.vue?macro=true";
import { default as kirghiziaq_iFXcPSBIY60cLdt953mysrmHEwOnyybwWuGMVpgt4Meta } from "/var/www/2025-10-08_20_30/pages/kirghizia.vue?macro=true";
import { default as mapSchemeGcNRt73TkwtEUwnMZMU_45tMadMfTh9aweM31OKj5lsT8Meta } from "/var/www/2025-10-08_20_30/pages/mapScheme.vue?macro=true";
import { default as _91id_93M5uMA9WDo0REZ_45ls0a0ZV8XTY4itmNb4yMUuOd8BdbYMeta } from "/var/www/2025-10-08_20_30/pages/news/[id].vue?macro=true";
import { default as return_45sdQE8g0GvZAwwDJJsurdr3S60aypP6zwehmyq7xnp2T7kMeta } from "/var/www/2025-10-08_20_30/pages/return-sd.vue?macro=true";
import { default as smsClientf9QyJMCNdPzmUcze6QGn6R7ddF6eSIvnGHei4Ezl5xMMeta } from "/var/www/2025-10-08_20_30/pages/smsClient.vue?macro=true";
import { default as terminals6z2GaQBFhshy_45GrPhKTiuV09Kpx_45zKiWBg0do_45kPN7QMeta } from "/var/www/2025-10-08_20_30/pages/terminals.vue?macro=true";
import { default as iframemz_45wo1Ez4w09RlQaO_guK4ZMS9moqJS1iAG5c8uex10Meta } from "/var/www/2025-10-08_20_30/pages/dev/iframe.vue?macro=true";
import { default as directionsEZbKoNQYsYT4djBbRAcLJw2Ff2xlSl03hABIK_xJV54Meta } from "/var/www/2025-10-08_20_30/pages/directions.vue?macro=true";
import { default as kazakhstanTAYaLKC2rJ0NiyfYr9fEny8YZm7tj1XvhHS8SpG8X1gMeta } from "/var/www/2025-10-08_20_30/pages/kazakhstan.vue?macro=true";
import { default as index8Dleof6CnaHh5_45CIHA5bKBhy3RaD0_DO2GwOS_45mRCn4Meta } from "/var/www/2025-10-08_20_30/pages/news/index.vue?macro=true";
import { default as svgYoqWmFP7iioc4QUTiNZQGTts2YEeHVE5MjBKPCSrn88Meta } from "/var/www/2025-10-08_20_30/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failgX86SBEunvEYqRnN3_45q7sgkJWWyaX5h5GmNN8BP2McoMeta } from "/var/www/2025-10-08_20_30/pages/vzpay-fail.vue?macro=true";
import { default as constructorvJBL9p_45BP8bAp1bkHzKE8SxfNmy_TyF5miAt09GosocMeta } from "/var/www/2025-10-08_20_30/pages/constructor.vue?macro=true";
import { default as indexT6Y3g61osuUt6d8VgwJJQRLJ0fybkDIlfUakNxAdvlEMeta } from "/var/www/2025-10-08_20_30/pages/gifts/index.vue?macro=true";
import { default as informationfCAJQhs9ND5Gs_aLTdoJ_HE9iOdyv5Dlv4chAuZjZwgMeta } from "/var/www/2025-10-08_20_30/pages/information.vue?macro=true";
import { default as claim_45filingB5J_pVvRn7VHCRyMYWb_458Spslaxwba2jQmtUzMbC39cMeta } from "/var/www/2025-10-08_20_30/pages/claim-filing.vue?macro=true";
import { default as _91type_93Fr986ziZBjou195R4zzYgMFJves5w7WvSvzkYkREliwMeta } from "/var/www/2025-10-08_20_30/pages/gifts/[type].vue?macro=true";
import { default as marketplacesM1EUOw4JT79THfjDsiAg9gVSZIXGOlf5tZfMNMidPJgMeta } from "/var/www/2025-10-08_20_30/pages/marketplaces.vue?macro=true";
import { default as networkshopsM3dXK6uW8uVnY6c_YhrEXbZK6vbf4FD_N8eRTYVGDSwMeta } from "/var/www/2025-10-08_20_30/pages/networkshops.vue?macro=true";
import { default as online_45store0vfUeVlhTDWSxFxlmnHTWOoU5n0ObewGWMRjLwXyYikMeta } from "/var/www/2025-10-08_20_30/pages/online-store.vue?macro=true";
import { default as manageNrra4sYDohGuDFs0AwvaiHHCzEUIjEZfWzG1F2y5BAQMeta } from "/var/www/2025-10-08_20_30/pages/order/manage.vue?macro=true";
import { default as registrationLW2Rae5zbiRSyTyxANib358R7HFA3zEQJhOIAt3L1oUMeta } from "/var/www/2025-10-08_20_30/pages/registration.vue?macro=true";
import { default as safe_45custodyhEnmH7onQh86jbIHiuM3jFhjLtPdKeuRgExWFRLKy6EMeta } from "/var/www/2025-10-08_20_30/pages/safe-custody.vue?macro=true";
import { default as image4SYJZig6ZHr5gC3LzfF3IVhL99GmhIkbrIu1HDsnO_UMeta } from "/var/www/2025-10-08_20_30/pages/ui-kit/image.vue?macro=true";
import { default as indexa91zMtEnrI505e57NSvvG8bV590Y_Oae4uSroaecjmsMeta } from "/var/www/2025-10-08_20_30/pages/ui-kit/index.vue?macro=true";
import { default as bagP4zzxwPiZislYxPuDkFyJ9mBFf9KxTQ1qC_45P_ZLoEsMMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/bag.vue?macro=true";
import { default as boxFvHoUNo_45LbH4UGbN6zfwhagg5eywIz4Nt_JNCq409w8Meta } from "/var/www/2025-10-08_20_30/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingVJojT9XC7S39gO6OKyT9RP4BR0IjLAlvhojKXIQveAcMeta } from "/var/www/2025-10-08_20_30/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayHhUrgAfYl1qnbi_ELxqnKhWTEXDd_HhtT_45iC8rrcAjMMeta } from "/var/www/2025-10-08_20_30/pages/happybirthday.vue?macro=true";
import { default as manageVS3GtwbcT2HKftHGi7RtG5U8SrrNkFsDu8zmz1aeDVwMeta } from "/var/www/2025-10-08_20_30/pages/iframe/manage.vue?macro=true";
import { default as authoUnlhC14zvKSfotF6nltZEw3_bVXq_455_VPKhkcCH4C8Meta } from "/var/www/2025-10-08_20_30/pages/personal/auth.vue?macro=true";
import { default as indexbO26cc_45l86ed0CRQ5nBnU1r09GEI0epVqAMft76AplkMeta } from "/var/www/2025-10-08_20_30/pages/tariffs/index.vue?macro=true";
import { default as public6QK5JoWHDsmSqaNgxerxtwGUbSvTh7dypeQzegK57cEMeta } from "/var/www/2025-10-08_20_30/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerh32RINoYR52EnrUg83buemqkl_Uok_45RkP27VTKWCMegMeta } from "/var/www/2025-10-08_20_30/pages/already-answer.vue?macro=true";
import { default as tariffsDAxJ39btm9JmeSFi7WznwfWjUxSXCSaJVJ_45_452G845owMeta } from "/var/www/2025-10-08_20_30/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93VgkfrnzFLKFAlZQIvfmBa8Kc0rENfj2IQcNkhexjOe8Meta } from "/var/www/2025-10-08_20_30/pages/order/pay/[id].vue?macro=true";
import { default as indexm9P4ORuLRCYa6qQa1pToZUSRQt_45VXWB5IgAV_45eexJIEMeta } from "/var/www/2025-10-08_20_30/pages/personal/index.vue?macro=true";
import { default as privacy_45policy_FBYWasPix3wlVDICuGNMJaW3OZNDbK7fYbv9kesQxwMeta } from "/var/www/2025-10-08_20_30/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93CQV6ii_VnkZfY3mqxxtGKkCvDy2pV5cA3SzTlU_45_KwgMeta } from "/var/www/2025-10-08_20_30/pages/welcome/[hash].vue?macro=true";
import { default as indexFEVDn2FH3TNE2sDf_45tvG34TuOIF40J1kWENwEGzvNHcMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiarVFC1CpqAEwAeqnbEJ07LY64WJC0XrGJI9Q7wzsskicMeta } from "/var/www/2025-10-08_20_30/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsVFpVH_45cw2JJrZMNMu0ofBAwB_45x5Rv0crvhPc5xE9z_sMeta } from "/var/www/2025-10-08_20_30/pages/payment-methods.vue?macro=true";
import { default as qr_45infoZXgy9y_GFEKRwR1sYH6y_45wrWmvCtfZ5YP5kNHO7KU7MMeta } from "/var/www/2025-10-08_20_30/pages/payment/qr-info.vue?macro=true";
import { default as successcthXiYcEjSXc58JzAbOZ0M8I6cBSzYruN_vYyQb7eoIMeta } from "/var/www/2025-10-08_20_30/pages/payment/success.vue?macro=true";
import { default as importbwzZLlzFLNTCZHcekcHGOeQivRyedrH1q3aLwu40ZTUMeta } from "/var/www/2025-10-08_20_30/pages/personal/import.vue?macro=true";
import { default as logoutX8kOFpJnRKPiAuLdi1jAsz311SzrFd__45B8dUmMuiYgIMeta } from "/var/www/2025-10-08_20_30/pages/personal/logout.vue?macro=true";
import { default as address_45delivery_45WZGzxXG98bEIjt1zmKxEQNYDD7LgzM3AY3TbEjDONYMeta } from "/var/www/2025-10-08_20_30/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliverynkbuojDXfn_45wz2peZQOlJl6QcTsJ1dPpVewx38S8eVUMeta } from "/var/www/2025-10-08_20_30/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024Tcq1MWgg15YoNdmOyAbM2RB6_455HdC_EYu__45_45zc_45lJycMeta } from "/var/www/2025-10-08_20_30/pages/happynewyear2024.vue?macro=true";
import { default as ozonQuU_LV7uZj0OjE_45S84pc6mr3DXgqrfD_45nU_h9cT1N80Meta } from "/var/www/2025-10-08_20_30/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failqnVRoLBdNMdYaxxoZfrY8koq0i8GIWqBEp3ZdFeAQvwMeta } from "/var/www/2025-10-08_20_30/pages/payment/pay-fail.vue?macro=true";
import { default as accountT4iS7u7DR_BiFF9fv0FavfOyI6ukvT1cZMHD8KK1rO8Meta } from "/var/www/2025-10-08_20_30/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsvWToDw8942DBKSeukpM5cdD6c1_45L82YNW88VZUWf3m4Meta } from "/var/www/2025-10-08_20_30/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completed7pwOaQu1LTro51Ql30dQhUy7i3dhSmVCoHspAcBq_45v0Meta } from "/var/www/2025-10-08_20_30/pages/survey-completed.vue?macro=true";
import { default as directionRf8aSbtj5Q_yoZ81zvot50NZZuVPzrfE273XZj65dyMMeta } from "/var/www/2025-10-08_20_30/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupmHIndc_45Y6CuXjeNeS0IO0lcGaUYS6KeoFMFLiAIRUokMeta } from "/var/www/2025-10-08_20_30/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargobccX1EVTtcoOT_8IkF2xJtNN4fjdrwz9Fxwm2xM3JvQMeta } from "/var/www/2025-10-08_20_30/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorC77oR2Zs_qCfLJ8OOvo3Iu993B_45_ojXT86usfbFIhX8Meta } from "/var/www/2025-10-08_20_30/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesaW_45B6TlWBMU6B5JIP7KYYhkr_0qxgUOEJX_av7jpOjcMeta } from "/var/www/2025-10-08_20_30/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93tEecO61sgkoL72VZeDjrMo6tccZUFsTAWoDviBFAxvMMeta } from "/var/www/2025-10-08_20_30/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoUuNpYXAY8af_LPZUdneEOtC2k2dEv_bOJYZlUGlDZFwMeta } from "/var/www/2025-10-08_20_30/pages/payment/card-info.vue?macro=true";
import { default as discountH8V4U3RrlQzy_MpnuaB6DzD7xcHLi4kx8BSnG8ANM54Meta } from "/var/www/2025-10-08_20_30/pages/personal/discount.vue?macro=true";
import { default as hard_45boxhdY_451hH_45KPhZW6M9lGoqy4YYtAOFdx9M6YXrCjmWKzkMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receipt4ZJzeXtRz9E1w7PaaZWN_45f5CvTVr24zoQjOGbTjUZs0Meta } from "/var/www/2025-10-08_20_30/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917jmSqN5A8QGSHpIQvAyVVuejzs7lfG0FMxEzL9sKhg4AMeta } from "/var/www/2025-10-08_20_30/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationKVf0ROJZS_y8ia_2wW2LmyHaMR3OXRDCjNdlvIgHQUUMeta } from "/var/www/2025-10-08_20_30/pages/mobile-application.vue?macro=true";
import { default as index6MreCcvSMaytddKeMgyBYUI253i1HJa3tf4J4BpYxucMeta } from "/var/www/2025-10-08_20_30/pages/order/create/index.vue?macro=true";
import { default as indexd7SPk8l_45MnGIUoRy53WUvdTmSl5NwADbK7d9nlI98LcMeta } from "/var/www/2025-10-08_20_30/pages/run-schedule/index.vue?macro=true";
import { default as boatxMlTCg6A_45DN2lIWKbpENcc3dMMZ7r9uyRKOeTm3ydg4Meta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/boat.vue?macro=true";
import { default as sofanYLFPl1f5TyXT3vSYyj2gPEYs3stHhd9psSBQjj8hQYMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93gt8mUhACul5F1Od_yjiXZBsz5zSUrTuJwUK5zXQ_45HzAMeta } from "/var/www/2025-10-08_20_30/pages/tariffs/[location].vue?macro=true";
import { default as cardboard368DwyDIgsxy4r08h49FqV3ZOBRQJAU_6y60qvUwP0kMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesQBHHxR9xk4BWC91UlIA2soJKkNxcqsNjRrbTPIO2jPgMeta } from "/var/www/2025-10-08_20_30/pages/personal/promocodes.vue?macro=true";
import { default as bench0DcX3Bv1TBkbf_KUSC5i1hpmf8tM8VSIA3yHGnJ97LMMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/bench.vue?macro=true";
import { default as bookswnWLWuzWN4VITaM3df_7hWk28AGK0uMHCmcKkkH_qE4Meta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/books.vue?macro=true";
import { default as cablexOb0OoidFcVNXZTYpg4ivboZ8HWHQwfPpEwqj_45FLh3gMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/cable.vue?macro=true";
import { default as chairVEjIVYu6bzTHv8snNLr7dUtroarz55LprZ8cdjaDM5AMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsYWH9QzVBO3_45WHjmu1xoIMYpolP2deY6iJSP5Qkx_45OWEMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/goods.vue?macro=true";
import { default as indexlKtsra_45lbs_4546mOXNedzF_45QQa7XS3qtuVKEXylJ1zOgMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/index.vue?macro=true";
import { default as metal6ds5Vj35zV9_45DCn37IdVO8rGE_xaftI_RsuFheM4l6AMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoYJnV5v2nFmCnMamvS4qfgX0mshs1GJhZuD9Upjv527MMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesE3kBIukPYZ_kcVWo6gAulAFM0zrFKgYKi7cHvOi93lgMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsjiuUi5ruSVYLo6y2B6DGNGmLS3fLFCWzom_z_45d3FS2IMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45box7j0gF8hpX4dfrxz4bfxNy0Z0qAgS_45DLVU4o_45_934VuUMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93wcNin80G_OaSa4Ddb0Q8t5jyvFJ4WnIa_ropnsG0isAMeta } from "/var/www/2025-10-08_20_30/pages/personal/bonus/[tab].vue?macro=true";
import { default as print1uZTSjoioH8E03dQ8KDe8ctoYlO_owGVdt2l_IH6TUQMeta } from "/var/www/2025-10-08_20_30/pages/personal/order/print.vue?macro=true";
import { default as dishesTeJrB0Mvh2DmWgRA_qCYfM55HjD8_45_tpxbuOQABVEUoMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginek6EOqHfcB6BDswz8VbfrAyIuZQacXGbqzrlItQ4yGwEMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberTvxYudIb2M_HdRThX_45GCuBH0Iak9oFALPFd9hLcludoMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsayZOQ24wAtNacbecwxEENHeNulK8htKDFRjwmtBPVI4Meta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmUZUiJggPo3Lu0zXnshnj8a86VBERpKxH90UykiOLvIgMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingch7Wp_0yjtWkiKl0_R6BHFIPxLE8qC0_zC_uFCHWOz0Meta } from "/var/www/2025-10-08_20_30/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalxar274QNBmEWPnfq2R7kAWzeca7DdYB3W1CGVgTOuBAMeta } from "/var/www/2025-10-08_20_30/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93cKP5q8mvSL5y_459OkwRmoHib64siOVbb1iGyPKI0BKRgMeta } from "/var/www/2025-10-08_20_30/pages/personal/order/[guid].vue?macro=true";
import { default as create_G3Ud3kSNcuTN2j3wZaitB4uDm_7noas_45L5rxs6cNI4Meta } from "/var/www/2025-10-08_20_30/pages/personal/order/create.vue?macro=true";
import { default as index48OKYxTuafISLBpDl0Ioi65vHUWZ1Mu8Y3WH6cBMI7wMeta } from "/var/www/2025-10-08_20_30/pages/safekeep/create/index.vue?macro=true";
import { default as barrelsTLcx9zwl7HZQWsrfrSqusgnn6GM6Uaqyg4kzwUl67IAMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesy_45zKg6zolfv5eQS9cXflEU96IFfUj9wbipPoP4HqvuAMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileObUSipNDsDFYtWuLnjcLZ35DzOtT1tbAX7f_kPvpAWEMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerihoZI0xDWsldVr8LnSt_cRmuGo44zTTaCDp8MDKnSSAMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagelWpQuDoVuyekIo_45Hw68dAb0K3QLz8Fn_45xfhw_45G_cq7MMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successqY7zZbXNvPGwhLdtAuuB2bkDEHjaC_6p9M0dzphxoMgMeta } from "/var/www/2025-10-08_20_30/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageJ_45h86TXy_45e0HOD_JqFDtp3UxjOLtDy5Wi1YzCajTbQcMeta } from "/var/www/2025-10-08_20_30/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriescOMFuYGIXdqs_s4iR9cq0dIXa4n6lho7ff0RH_45b2tPAMeta } from "/var/www/2025-10-08_20_30/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_935Qg8NB_vXiLxe73HVzKcCEDuXnKr6ye5S4VfgTg9hcEMeta } from "/var/www/2025-10-08_20_30/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_93sdkzNcwhzgrTPd9jkTR4OgSX5hDv4ozSQUbXZi6RR2UMeta } from "/var/www/2025-10-08_20_30/pages/run-schedule/[location].vue?macro=true";
import { default as furniture_gxgzK9ycpRbYYfPBENmlZC8s_oPUT7qBeZDCKnCrvYMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedw7CMP9lfL9hxDBc_1LUj_K9Q_rCOZ_45YSyGGAOI4ENyUMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeVu3KAjdonIubkMA9ULFoLAvjRNmvpxGgzX43fWrNTGsMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93GznUtjDeXMdUk9ctpDg1be8_45_vvAxKVedzagj8dNTXMMeta } from "/var/www/2025-10-08_20_30/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_931e0uiFLy4jXjAzWLwSps6SwGJX_EKGQXGB__lXQb7XoMeta } from "/var/www/2025-10-08_20_30/pages/personal/orders/[...tab].vue?macro=true";
import { default as _91guid_93gSzxfMKJ1ZtLbQMUlmEqOjEr7it3L8mtYu6aNHpxBrMMeta } from "/var/www/2025-10-08_20_30/pages/personal/safekeep/[guid].vue?macro=true";
import { default as createtftz3om2NVvJ_45WWdr3JHioTG_8LhFfbg8skt_pNqEeIMeta } from "/var/www/2025-10-08_20_30/pages/personal/safekeep/create.vue?macro=true";
import { default as auto_45parts1aWKd6Nc_PlGjD5s6lCQ0IcWFkru1clkgaNeDT3wwzgMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspaperstXr8P8NcEHzTkA1MzLousQGk3_ui1qWhsllqnE_IHqgMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoxXylj0nUE38fNjE7fIme8PmlW9JGsF1FcPC3a75JtNUMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilespw3x13l82T10kfsVyoVmSukSBbLxUc6ZNNjkl4LQOMMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexMgtJ7ZYCPnZlP7LOAEoRewXaQHFNPTaT118j2nU8bBQMeta } from "/var/www/2025-10-08_20_30/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketvp_hPrnxhTBPBhZVVbnJLhHCSDeNJHj7fPKRdS21nnoMeta } from "/var/www/2025-10-08_20_30/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatescXBNAafp51b88HKJRkTEKMtnRLEixucNQHA6Vd0cTfEMeta } from "/var/www/2025-10-08_20_30/pages/personal/orders/templates.vue?macro=true";
import { default as indexABi2BLMj05D8QQyz6G2wjwAX1hXASdNUchn7A_452iSq8Meta } from "/var/www/2025-10-08_20_30/pages/personal/contractors/index.vue?macro=true";
import { default as _91guid_934cpowfktB_45yQ76e8ol_aZEl67u0LCLt4Du0HqxyOjzYMeta } from "/var/www/2025-10-08_20_30/pages/personal/order-ozon/[guid].vue?macro=true";
import { default as _91guid_93G2ZaG1TR8gnK7IGHb1yeDpFqjEn5Kh1gQfeV2fu_BZgMeta } from "/var/www/2025-10-08_20_30/pages/safekeep/administer/[guid].vue?macro=true";
import { default as refrigeratorMATNxQwQld22ksK_skqExSirz5GDZVkDCeze_D99EoAMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93gtoBKF8fBriPbLYnAsJ6PqWngEr2TK7420GNOdtac2sMeta } from "/var/www/2025-10-08_20_30/pages/personal/contractors/[guid].vue?macro=true";
import { default as index3NAQKGv6pEd56FQ3aksTHWIaxK1TwF9QhhYLt6hnEfAMeta } from "/var/www/2025-10-08_20_30/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91_46_46_46tab_93GxpK4LlfAvicS7cuPs_z0ULOoDcr8N0ojfbLokggr0IMeta } from "/var/www/2025-10-08_20_30/pages/personal/safekeeps/[...tab].vue?macro=true";
import { default as _91guid_93q80fAYweYiWXTMJWDWO5hUS2G7li8m6m_45xmw2zq8lM0Meta } from "/var/www/2025-10-08_20_30/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsHEEg26ILzYmARQH4T8jcA7FxPZJLOXJ91WCYPg2KN1MMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexKTPiFKisqzpd6nOjKqY0q_45_45wytKOzEOnhaYA_45AWShmMMeta } from "/var/www/2025-10-08_20_30/pages/personal/group-printing/index.vue?macro=true";
import { default as indexoT1mcosaxtPhcCSLfpxoEr2Gy3UrSYBc3YJjoMLw6pwMeta } from "/var/www/2025-10-08_20_30/pages/personal/multi-delivery/index.vue?macro=true";
import { default as _91_46_46_46tab_93wVhww_45CDS612LGRZeyIMoX1JiNo5BLsraPG0oYIkMIsMeta } from "/var/www/2025-10-08_20_30/pages/personal/orders-ozon/[...tab].vue?macro=true";
import { default as medical_45devicesLdkbKWyv_pL8CHOFegERpqAQO4WwyXJC8ObjTB7S_4EMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93wxL0_LVFyYnoyrbx1wHBh7WjhaB9lzU434wiatCQh_UMeta } from "/var/www/2025-10-08_20_30/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93P0wCDxiNxJjh9qgXA8dI_45qdl8fAcUFEP_45YjyVw7w7yIMeta } from "/var/www/2025-10-08_20_30/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93fgOJghWR0C_mpI9IsYps1hz2gkp4qZWtGbT747SCLsAMeta } from "/var/www/2025-10-08_20_30/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentpdsoCzCOjL_45q57VrKwEFmn7VKuA60u_45CXzYXxnZPp9cMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialslwcJn0o7TQaU1sj0YIUjhLLEu8ezdOApfh9ANTHRNG8Meta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instruments_R2NrPmuZUcpBGyE8dFSMdWrEuOjSSExmIlmXAtdR7YMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipment3SUaqSbExRdwr220SzM3MAzraxXspxiPrCoK9AuEvioMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationjEa0lxIdYxNB9UIPYq_8_5RXTyvxeHk_UZd0p9yYDMgMeta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93_45nTyJH3EXTzThNahPtGiAeYRqhV0j_4v_4WNOIAZty0Meta } from "/var/www/2025-10-08_20_30/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportation7paDLEuu9q6EXvAvjCHcA5N3UVV3_45HTVBiHsJ5lSGF8Meta } from "/var/www/2025-10-08_20_30/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-10-08_20_30/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-10-08_20_30/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-10-08_20_30/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-10-08_20_30/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93MZjQdvuEGdGgyWwYbOeMTMFNhEsM_QdOhwntSvQ5HYkMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-10-08_20_30/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: surveyKkZqFBMjKfKcthnF4GFRlxzI6BfhowN0wUUzbi91JXoMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-10-08_20_30/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-10-08_20_30/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-10-08_20_30/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-10-08_20_30/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursrZEyNpRUKD7m7xnPEArHbecedJ8A1icXHiWfHJFW8ysMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-10-08_20_30/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-10-08_20_30/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsxlD60LNA0WJRMQ9OwG_hZR8K2dtjf69CmhU7bjOlzCQMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-10-08_20_30/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-10-08_20_30/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-10-08_20_30/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-10-08_20_30/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-10-08_20_30/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-10-08_20_30/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-10-08_20_30/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-10-08_20_30/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeGcNRt73TkwtEUwnMZMU_45tMadMfTh9aweM31OKj5lsT8Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93M5uMA9WDo0REZ_45ls0a0ZV8XTY4itmNb4yMUuOd8BdbYMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-10-08_20_30/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-10-08_20_30/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-10-08_20_30/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-10-08_20_30/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-10-08_20_30/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-10-08_20_30/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: index8Dleof6CnaHh5_45CIHA5bKBhy3RaD0_DO2GwOS_45mRCn4Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-10-08_20_30/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-10-08_20_30/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorvJBL9p_45BP8bAp1bkHzKE8SxfNmy_TyF5miAt09GosocMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexT6Y3g61osuUt6d8VgwJJQRLJ0fybkDIlfUakNxAdvlEMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-10-08_20_30/pages/information.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-10-08_20_30/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93Fr986ziZBjou195R4zzYgMFJves5w7WvSvzkYkREliwMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-10-08_20_30/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-10-08_20_30/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-10-08_20_30/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-10-08_20_30/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-10-08_20_30/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-10-08_20_30/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-10-08_20_30/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-10-08_20_30/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayHhUrgAfYl1qnbi_ELxqnKhWTEXDd_HhtT_45iC8rrcAjMMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageVS3GtwbcT2HKftHGi7RtG5U8SrrNkFsDu8zmz1aeDVwMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-10-08_20_30/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-10-08_20_30/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-10-08_20_30/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsDAxJ39btm9JmeSFi7WznwfWjUxSXCSaJVJ_45_452G845owMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexm9P4ORuLRCYa6qQa1pToZUSRQt_45VXWB5IgAV_45eexJIEMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-10-08_20_30/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-10-08_20_30/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-10-08_20_30/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importbwzZLlzFLNTCZHcekcHGOeQivRyedrH1q3aLwu40ZTUMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutX8kOFpJnRKPiAuLdi1jAsz311SzrFd__45B8dUmMuiYgIMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-10-08_20_30/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-10-08_20_30/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024Tcq1MWgg15YoNdmOyAbM2RB6_455HdC_EYu__45_45zc_45lJycMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonQuU_LV7uZj0OjE_45S84pc6mr3DXgqrfD_45nU_h9cT1N80Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountT4iS7u7DR_BiFF9fv0FavfOyI6ukvT1cZMHD8KK1rO8Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-10-08_20_30/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completed7pwOaQu1LTro51Ql30dQhUy7i3dhSmVCoHspAcBq_45v0Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-10-08_20_30/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-10-08_20_30/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-10-08_20_30/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorC77oR2Zs_qCfLJ8OOvo3Iu993B_45_ojXT86usfbFIhX8Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-10-08_20_30/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountH8V4U3RrlQzy_MpnuaB6DzD7xcHLi4kx8BSnG8ANM54Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-10-08_20_30/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917jmSqN5A8QGSHpIQvAyVVuejzs7lfG0FMxEzL9sKhg4AMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-10-08_20_30/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: index6MreCcvSMaytddKeMgyBYUI253i1HJa3tf4J4BpYxucMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-10-08_20_30/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-10-08_20_30/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesQBHHxR9xk4BWC91UlIA2soJKkNxcqsNjRrbTPIO2jPgMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93wcNin80G_OaSa4Ddb0Q8t5jyvFJ4WnIa_ropnsG0isAMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: print1uZTSjoioH8E03dQ8KDe8ctoYlO_owGVdt2l_IH6TUQMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-10-08_20_30/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93cKP5q8mvSL5y_459OkwRmoHib64siOVbb1iGyPKI0BKRgMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create_G3Ud3kSNcuTN2j3wZaitB4uDm_7noas_45L5rxs6cNI4Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/order/create.vue")
  },
  {
    name: "safekeep-create",
    path: "/safekeep/create",
    meta: index48OKYxTuafISLBpDl0Ioi65vHUWZ1Mu8Y3WH6cBMI7wMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/safekeep/create/index.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-10-08_20_30/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-10-08_20_30/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriescOMFuYGIXdqs_s4iR9cq0dIXa4n6lho7ff0RH_45b2tPAMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-10-08_20_30/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_931e0uiFLy4jXjAzWLwSps6SwGJX_EKGQXGB__lXQb7XoMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/orders/[...tab].vue")
  },
  {
    name: "personal-safekeep-guid",
    path: "/personal/safekeep/:guid",
    meta: _91guid_93gSzxfMKJ1ZtLbQMUlmEqOjEr7it3L8mtYu6aNHpxBrMMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/safekeep/[guid].vue")
  },
  {
    name: "personal-safekeep-create",
    path: "/personal/safekeep/create",
    meta: createtftz3om2NVvJ_45WWdr3JHioTG_8LhFfbg8skt_pNqEeIMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/safekeep/create.vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexMgtJ7ZYCPnZlP7LOAEoRewXaQHFNPTaT118j2nU8bBQMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketvp_hPrnxhTBPBhZVVbnJLhHCSDeNJHj7fPKRdS21nnoMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatescXBNAafp51b88HKJRkTEKMtnRLEixucNQHA6Vd0cTfEMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexABi2BLMj05D8QQyz6G2wjwAX1hXASdNUchn7A_452iSq8Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/contractors/index.vue")
  },
  {
    name: "personal-order-ozon-guid",
    path: "/personal/order-ozon/:guid",
    meta: _91guid_934cpowfktB_45yQ76e8ol_aZEl67u0LCLt4Du0HqxyOjzYMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/order-ozon/[guid].vue")
  },
  {
    name: "safekeep-administer-guid",
    path: "/safekeep/administer/:guid()",
    component: () => import("/var/www/2025-10-08_20_30/pages/safekeep/administer/[guid].vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93gtoBKF8fBriPbLYnAsJ6PqWngEr2TK7420GNOdtac2sMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: index3NAQKGv6pEd56FQ3aksTHWIaxK1TwF9QhhYLt6hnEfAMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-safekeeps-tab",
    path: "/personal/safekeeps/:tab(.*)*",
    meta: _91_46_46_46tab_93GxpK4LlfAvicS7cuPs_z0ULOoDcr8N0ojfbLokggr0IMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/safekeeps/[...tab].vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93q80fAYweYiWXTMJWDWO5hUS2G7li8m6m_45xmw2zq8lM0Meta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexKTPiFKisqzpd6nOjKqY0q_45_45wytKOzEOnhaYA_45AWShmMMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexoT1mcosaxtPhcCSLfpxoEr2Gy3UrSYBc3YJjoMLw6pwMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "personal-orders-ozon-tab",
    path: "/personal/orders-ozon/:tab(.*)*",
    meta: _91_46_46_46tab_93wVhww_45CDS612LGRZeyIMoX1JiNo5BLsraPG0oYIkMIsMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/orders-ozon/[...tab].vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93wxL0_LVFyYnoyrbx1wHBh7WjhaB9lzU434wiatCQh_UMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93P0wCDxiNxJjh9qgXA8dI_45qdl8fAcUFEP_45YjyVw7w7yIMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93fgOJghWR0C_mpI9IsYps1hz2gkp4qZWtGbT747SCLsAMeta || {},
    component: () => import("/var/www/2025-10-08_20_30/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-10-08_20_30/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-10-08_20_30/pages/shippingtypes/personalitemstransportation.vue")
  }
]